import { render, staticRenderFns } from "./ShootingFrequency.vue?vue&type=template&id=88c3382c&"
import script from "./ShootingFrequency.vue?vue&type=script&lang=js&"
export * from "./ShootingFrequency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports